module.exports = __webpack_public_path__ + "bb5b68d7038e9080d570e88cadf563d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/pioneer_investments.png
// module id = 1719
// module chunks = 0